import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import _ from 'lodash';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Player } from '../models/student';

@Injectable({
  providedIn: 'root'
})
export class PlayerService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  // [POST] add player to team
  public createPlayer(player: Player): Observable<{ [index: string]: any; }> {
    return this.httpClient.post<HttpResponse<object>>
      (environment.api_server + environment.api_endpoints.players, player, {
        params: {}, observe: 'response'
      });
  }

  // [DELETE] player from team
  public deletePlayer(player: Player): Observable<{ [index: string]: any; }> {
    return this.httpClient.delete<HttpResponse<object>>
      (environment.api_server + _.replace(environment.api_endpoints.playersDelete, ':id', player.id || ''),  
      { params: {}, observe: 'response' });
  }
}
